// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608270836/js/" + chunkId + "." + {"44":"90da2ac9","225":"791f9d6e","481":"a5bf3b23","486":"ffb4feb6","770":"ee72e436"}[chunkId] + ".0.3490836279849151.chunk.js";
};